var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "campaign-list-item" }, [
    _c(
      "div",
      {
        staticClass: "campaign-heading flex flex-row",
        class: _vm.campaign.bookings_count ? "cursor-pointer" : "",
        on: { click: _vm.toggleBookings },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "campaign-heading__main" },
          [
            _c("div", [
              _vm._v(
                "\n        Campaign | " + _vm._s(_vm.campaign.name) + "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "campaign-heading__main--link",
                attrs: {
                  to: {
                    name: "campaign.edit",
                    params: { id: _vm.campaign.id },
                  },
                },
              },
              [
                _vm._v("\n        View Campaign "),
                _c("i", { staticClass: "fa fa-chevron-right" }),
              ]
            ),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "campaign-body" },
      [
        _c("div", { staticClass: "flex flex-row justify-between margin-b-5" }, [
          _c("div", { staticClass: "w-3/4" }, [
            _c("p", { staticClass: "campaign-body__description" }, [
              !_vm.campaign.bookings_count
                ? _c("span", { staticClass: "draft-label" }, [_vm._v("Draft")])
                : _vm._e(),
              _vm._v(_vm._s(_vm.campaign.stripped_description)),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-calendar margin-r-1" }),
            _vm._v(
              " Start Date: " +
                _vm._s(_vm._f("date")(_vm.campaign.start_date)) +
                " "
            ),
            _vm.campaign.end_date
              ? _c("span", [
                  _vm._v(
                    "| End Date: " +
                      _vm._s(_vm._f("date")(_vm.campaign.end_date))
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col items-end w-1/4" }, [
            _c(
              "div",
              {
                staticClass: "toggle-button",
                class: !_vm.campaign.bookings_count
                  ? "toggle-button--disabled"
                  : "",
                on: { click: _vm.toggleBookings },
              },
              [
                _c("i", {
                  staticClass: "fa",
                  class: _vm.bookings_expanded
                    ? "fa-chevron-up"
                    : "fa-chevron-down",
                }),
              ]
            ),
            _vm._v(
              "\n        Requests: " +
                _vm._s(_vm.campaign.bookings_count) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.bookings_expanded && _vm.campaign.bookings_count
          ? _c(
              "ul",
              { staticStyle: { "padding-left": "0" } },
              _vm._l(_vm.campaign.bookings, function (booking) {
                return _c("campaign-list-item-booking-list-item", {
                  key: booking.id,
                  attrs: { booking: booking },
                })
              }),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.bookings_expanded && _vm.campaign.bookings_count > 5
          ? _c(
              "div",
              { staticClass: "flex justify-center spacer-t-3 underline" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "campaign.edit",
                        params: { id: _vm.campaign.id },
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "Show " +
                          _vm._s(_vm.campaign.bookings_count - 5) +
                          " more"
                      ),
                    ]),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.campaign.bookings_count
          ? _c(
              "router-link",
              {
                staticClass: "create-request",
                attrs: {
                  to: {
                    name: "requests.create",
                    query: { campaign_id: _vm.campaign.id },
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" Create request\n    "),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "campaign-heading__highlight" }, [
      _c("i", { staticClass: "fa fa-clone fa-lg" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }